<template>
  <div>
    <table-layout
      pkField="id"
      :selected.sync="selected"
      :isAdmin="isAdmin"
      :loading="serversLoading"
      :items="lists"
      :columns="columns"
      :addOptions="listsTypes"
      @click:addNew="addList"
    >
      <template #actions>
        <b-dropdown-item @click="update" aria-role="listitem">{{ $t('lists.update') }}</b-dropdown-item>
        <b-dropdown-item @click="openDialogRemove" aria-role="listitem">{{ $t('lists.deleteDetail') }}</b-dropdown-item>
      </template>
    </table-layout>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import TableLayout from '@/layout/TableLayout'

const { mapState: mapUserState } = createNamespacedHelpers('general')

export default {
  name: 'Lists',
  components: {
    TableLayout
  },
  mounted() {
    this.refetch()
    this.getTypes()
  },
  computed: {
    ...mapUserState({
      role: state => state.user.role
    }),
    isAdmin() {
      return this.role === 'ADMIN'
    }
  },
  data() {
    return {
      lists: [],
      serversLoading: false,
      listsTypes: [],
      columns: [
        {
          sortable: true,
          field: 'name',
          label: 'columns.name',
          route: {
            name: 'list',
            params: [
              {
                name: 'list_id',
                field: 'id'
              }
            ]
          }
        },
        {
          sortable: true,
          field: 'type',
          label: 'columns.list_type'
        },
        {
          sortable: true,
          field: 'created_by',
          label: 'columns.created_by'
        },
        {
          sortable: true,
          field: 'last_status',
          label: 'columns.list_last_update'
        },
        {
          sortable: true,
          field: 'number of items',
          label: 'columns.number_of_items'
        },
        {
          sortable: true,
          field: 'description',
          label: 'columns.description'
        }
      ],
      selected: []
    }
  },
  methods: {
    addList(type) {
      this.$router.push({
        name: 'add_list',
        query: { type: type }
      })
    },
    refetch() {
      if (!this.serversLoading) {
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/lists`
        this.serversLoading = true
        fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.lists = data
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.serversLoading = false
          })
      }
    },
    update() {
      if (!this.serversLoading) {
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/lists/update`
        this.serversLoading = true
        fetch(url, {
          credentials: 'include',
          body: JSON.stringify({
            list_ids: this.selected
          }),
          method: 'POST'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.lists = data
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.serversLoading = false
          })
      }
    },
    getTypes() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/lists/types`
      fetch(url, {
        method: 'GET',
        credentials: 'include'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(data => {
          this.listsTypes = data
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    deleteLists(list_ids, msg) {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/lists/delete`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          list_ids: list_ids
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          this.$notify({
            message: this.$t('notification.removed', {
              msg: msg
            }),
            type: 'success'
          })
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    openDialogRemove() {
      if (!this.selected.length) {
        this.$notify({
          message: this.$t('notification.unselected'),
          type: 'danger'
        })
        return
      }
      const indexSet = new Set(this.selected)
      const lists = this.lists
        .filter(value => {
          return indexSet.has(value.id)
        })
        .map(d => {
          return d['name']
        })
      const msg = lists
        .map(d => {
          return d
        })
        .join(', ')

      this.$dialog.confirm({
        message: `${this.$t('confirm.remove', {
          msg: msg
        })}?`,
        onConfirm: () => {
          this.serversLoading = true
          this.deleteLists(this.selected, msg).finally(() => {
            this.serversLoading = false
            this.refetch()
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  width: 100%;
}
</style>
